import { render, staticRenderFns } from "./PropertiesCard.vue?vue&type=template&id=505a91c3&scoped=true"
import script from "./PropertiesCard.vue?vue&type=script&lang=js"
export * from "./PropertiesCard.vue?vue&type=script&lang=js"
import style0 from "./PropertiesCard.vue?vue&type=style&index=0&id=505a91c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a91c3",
  null
  
)

export default component.exports